import { dataInsightsApp } from '@app/app-routes/data-insights';
import { criticalListsApp } from '@app/app-routes/critical-lists';
import { dataManagementApp } from '@app/app-routes/data-management';
import { curveBuilderApp } from '@app/app-routes/curve-builder';
import { aiApp } from '@app/app-routes/ai';
import { administrationApp } from '@app/app-routes/administration';
import { SphereAppCategory, SphereAppCategoryListItem } from '@app/app-routes/__app-route__';

export const SphereAppCategories: SphereAppCategoryListItem[] = [
    {
        category: SphereAppCategory.MarketDataMonitoring,
        priority: 0,
        logoSvg: dataInsightsApp.data.logoSvg,
        backgroundAccentColor: dataInsightsApp.data.cardBackground
    },
    {
        category: SphereAppCategory.MarketDataEntitlements,
        priority: 0,
        logoSvg: criticalListsApp.data.logoSvg,
        backgroundAccentColor: criticalListsApp.data.cardBackground
    },
    {
        category: SphereAppCategory.CustomDataAndAutomation,
        priority: 0,
        logoSvg: dataManagementApp.data.logoSvg,
        backgroundAccentColor: dataManagementApp.data.cardBackground
    },
    {
        category: SphereAppCategory.ForwardCurves,
        priority: 0,
        logoSvg: curveBuilderApp.data.logoSvg,
        backgroundAccentColor: curveBuilderApp.data.cardBackground
    },
    {
        category: SphereAppCategory.InsightsAndIntelligence,
        priority: 0,
        logoSvg: aiApp.data.logoSvg,
        backgroundAccentColor: aiApp.data.cardBackground
    },
    {
        category: SphereAppCategory.AdministrationAndConfigurationTools,
        priority: 2,
        logoSvg: administrationApp.data.logoSvg,
        backgroundAccentColor: administrationApp.data.cardBackground
    }
];
